import React from 'react';
import GlobalRegulatoryReference from '../regulatory/GlobalRegulatoryReference';
import RegulatoryEvents from '../regulatory/RegulatoryEvents';
import Disclaimer from '../Disclaimer';

// Global Regulatory Reference surface (owner audit 2026-09-26): regulatory reference and regulatory events
// only. Security is its own surface (SecurityEvidencePanel) — the two are different analytical objects.
export default function ComplianceSection() {
  return (
    <div className="space-y-8">
      <GlobalRegulatoryReference />
      <RegulatoryEvents months={12} />
      <Disclaimer variant="compact" />
    </div>
  );
}
